
const FalloIniciarLoginView = () =>
  import('../../../statics/views/FalloIniciarLoginView.vue');

export default [
  {
    path: '/FalloIniciarLoginView',
    name: 'FalloIniciarLoginView',
    component: FalloIniciarLoginView,
    meta: {
      title: 'Fallo Iniciar sesion',
      requiresAuthentication: false,
      requiresAuthorization: false,
      bread: {
        path: [
          'Error',
        ],
      },
    },
  },
];
